import { SerieDependency } from '../@models/serieDependencie.model'

export class MillType extends SerieDependency {
  constructor(id: number, name: string) {
    super(id, name)
  }
}
